import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  Create
} from "adminApi/CustomersApi/Customers";
import { validateForm } from "utils/validation";
import { CustomersRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddCustomerForm from "./Componates/AddCustomerForm";
import fields from "../json/CustomersFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddCustomer = () => {
  const navigate = useNavigate();
  // Combine all possible fields for default state (memoized to prevent reruns)
  const allFields = useMemo(
    () => [...fields.common, ...fields.native, ...fields.foreigner, ...fields.country_dial_code],
    []
  );

  const initialValues = useMemo(() => {
    return allFields.reduce((acc, field) => {
      acc[field.name] = "";
      return acc;
    }, {});
  }, [allFields]);

  const { values, errors, handleChange, handleFileChange, setErrors } =
    useFormChange(initialValues, CustomersRules);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        formData.append(key, val ?? "");
      });
      return await Create({ data: formData });
    },
    (vals) => {
      // Copy before mutating to avoid modifying original state
      const v = { ...vals };
      delete v.img_frontPreview;
      delete v.img_backPreview;
      delete v.img_guestPreview;
      delete v.profile_imagePreview;
      if (v?.is_nationality === "national") {
        fields.foreigner.forEach((field) => delete v[field.name]);
      } else if (v?.is_nationality === "foreigner") {
        fields.native.forEach((field) => delete v[field.name]);
      }
      const err = validateForm(v, CustomersRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Customer Created successfully!"
  );
  return (
    <>
      {(loadingSubmit) && <Spinner isSpinner={true} />}
      <AddCustomerForm
        fields={fields}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        handleFileChange={handleFileChange}
        title="Created Customer"
        img_frontPreview={values.img_frontPreview || values.img_front}
        img_backPreview={values.img_backPreview || values.img_back}
        img_guestPreview={values.img_guestPreview || values.img_guest}
        profile_imagePreview={values.profile_imagePreview || values.profile_image}
      />
    </>
  );
};

export default AddCustomer;
